import React from 'react';
import { QualityGapModal } from '~/components/Patient';
import { handleButtonKeypress } from '~/util';

interface NotePCMQualityProps {
    entity: NoteType | ReminderType;
    gap?: null | GapType;
    patientId: number;
}
export function NotePCMQuality({ entity, gap = null, patientId }: NotePCMQualityProps) {
    const [modalOpen, setModalOpen] = React.useState(false);
    if (entity.quality_gap && gap) {
        return (
            <>
                <div
                    className="d-inline-block fw-bold link-text"
                    onKeyUp={(e) => handleButtonKeypress(e, () => setModalOpen(true))}
                    onClick={() => setModalOpen(true)}
                    role="button"
                    tabIndex={0}
                >
                    {entity.quality_gap?.measure
                        ? entity.quality_gap.measure?.short_name
                        : gap?.measure?.short_name}
                </div>
                {modalOpen && (
                    <QualityGapModal
                        qualityGap={gap}
                        patientId={patientId}
                        handleClose={() => setModalOpen(false)}
                    />
                )}
            </>
        );
    }
    return <span className="fw-bold">{entity?.quality_gap?.measure?.short_name}</span>;
}
